export default "__VITE_ASSET__1a1b6f66__"